import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { permisopagina } from 'src/app/models/permisopagina';
import { usuario } from 'src/app/models/usuario';
import { ApiauthService } from 'src/app/services/apiauth.service';
import { ExtencionService } from 'src/app/services/extencion.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  usuario: usuario;
  public permisos: permisopagina[] = [];
  public imgUrl = '';
  permiteExtencion = false;
  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter();

  constructor(
    public apiAuth: ApiauthService,
    public extencionSvc: ExtencionService,
    public permisoService: PermissionService
  ) {
    this.usuario = this.apiAuth.usuarioData;

    this.imgUrl = 'data:image/png;base64,' + this.usuario.photoProfileSmall;
    if (this.usuario.photoProfileSmall.startsWith('./assets')) {
      this.imgUrl = this.usuario.photoProfileSmall;
    }

  //  console.log('CONTRUCTOR DEL MENU');
  }

  ngOnInit(): void {
    this.permisoService.loadPermissions().subscribe((paginas) => {
      console.log('las paginas son: ', paginas);
      this.permisos = paginas;
    });
    this.extencionSvc.permiteExtencionesServicios().subscribe((result) => {
      this.permiteExtencion = result;
    });
  }

  toggleSideBar() {
    this.toggleSideBarForMe.emit();
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  hasPermision(url: string) {
    return this.permisos.filter((x) => x.url == url).length >= 1;
  }
}
